export default __webpack_public_path__ + "static/Kia Rio-7206231c4e819c19d0eea99daf89f05f.jpg";